import { weatherRasterTileConfigs } from "./weather/RasterTile";
import { vegetationRasterTileConfigs } from './vegetation/RasterTile'
import { dfciRasterTileConfigs } from "./dfci/RasterTile"
export const rasterTileRegistry = {
  ...weatherRasterTileConfigs,
  ...vegetationRasterTileConfigs,
  ...dfciRasterTileConfigs,

};